import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppointmentCreate, Record } from '../../models';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppointmentService {

  constructor(
    private http: HttpClient
  ) { }

  public getAll(date: string, live_queue: number) {
    let queries = '?date=' + date + '&live_queue=' + live_queue;

    return this.http.get<{
      code: string;
      data: Array<Record>
    }>(`${environment.host}/note/appointments/${queries}`);
  }

  public create(data: AppointmentCreate) {
    return this.http.post<{
      code: string;
      data: any,
      message: string
    }>(`${environment.host}/note/operation/create/`, data);
  }
}
